export default "__VITE_ASSET__BSzyvy6F__"